import { isDefined } from '@sgme/fp';

import { BlotterDetailsField } from '@/App/Blotter/grids/details/BlotterDetailsField.tsx';
import { useUserContext } from '@/context/UserContext.tsx';
import type { BlotterOptionEntry } from '@/store/blotter/types/BlotterOptionEntry.ts';

type Props = {
  entry: BlotterOptionEntry;

  labelDataE2e?: string;
  valueDataE2e?: string;
};

export const PremiumDetailsField = ({ entry, labelDataE2e, valueDataE2e }: Props) => {
  const {
    currentUser: { userType },
  } = useUserContext();

  const isInternalSales = userType === 'Internal Sales';

  return (
    <BlotterDetailsField
      labelI18NKey={
        isDefined(entry.premiumSide) && entry.premiumSide !== ''
          ? `blotter.tab.Option.details.premium.${entry.premiumSide}.${isInternalSales ? 'isInternalSales' : 'isNotInternalSales'}`
          : 'blotter.tab.Option.details.premium'
      }
      formatting="amount"
      value={entry.premium ?? 0}
      currency={entry.premiumCurrency ?? ''}
      labelDataE2e={labelDataE2e}
      valueDataE2e={valueDataE2e}
    />
  );
};
